import { buildEventId } from '~/utilities/metaCapiEventIds'

function trackWhenReady(eventName, eventId, customData) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  window.fbq('track', eventName, customData ?? {}, { eventID: eventId })
}

export function trackMetaBrowserLead(ticketId) {
  trackWhenReady('Lead', buildEventId('traffic_submit', ticketId))
}

export function trackMetaBrowserPurchase(ticketId, value) {
  if (!Number.isFinite(value) || value <= 0) return
  trackWhenReady('Purchase', buildEventId('traffic_converted', ticketId), {
    value,
    currency: 'USD',
  })
}
